// extracted by mini-css-extract-plugin
export var item = "how-academy-works-item-module--item--6p5sm";
export var title = "how-academy-works-item-module--title--Bb+FD";
export var description = "how-academy-works-item-module--description--EXj+0";
export var shape = "how-academy-works-item-module--shape--jEW7g";